<template>
  <div class="c-app flex-row align-items-center" id="diagnosis">
    <CContainer>
      <CRow id="app-wrap" @click="closeMenu" class="justify-content-center">
        <CCol col="12" lg="12">
          <CCard class="app-card">
            <ul class="c-header-nav mr-4">
              <li class="c-header-nav-items dropdown nav-item">
                <div class="c-avatar" @click.stop="openMenu"></div>
                <div class="pt-0 my-dropdown-menu" v-show="isShowMenu">
                  <a @click="goMyAccount" class="dropdown-item myaccount" role="menuitem" >MyAccount</a>
                  <a href="/app/color/" class="dropdown-item logout" role="menuitem">Logout</a>
                </div>
                <div class="pt-0 my-dropdown-menu" v-show="isShowTime" @click="closeMenu">
                  <a @click="startAutoPlay(300)" class="dropdown-item">0.3秒</a>
                  <a @click="startAutoPlay(500)" class="dropdown-item">0.5秒</a>
                  <a @click="startAutoPlay(1000)" class="dropdown-item">1秒</a>
                </div>
              </li>
            </ul>
            <div class="my-dropdown-menu-bg" v-if="!isPC()" v-show="isShowMenu || isShowTime" @click="closeMenu"></div>
            <div
              v-show="step == 1"
              class="droparea" 
              @dragenter="dragEnter"
              @dragleave="dragLeave"
              @dragover.prevent 
              @drop.prevent="dropFile"
              :class="{enter: isDropEnter}">
              <input type="file" @change="onFileChange" class="file_change"/>
              <h1>写真をアップしてください</h1>
            </div>
            <CCardBody class="px-0 py-0" v-show="step == 2 || step == 3">
              <div class="view">
                <span id="icon-left" @click="colorChangeLeft" v-show="step == 3"></span>
                <span id="icon-right" @click="colorChangeRight" v-show="step == 3"></span>
                <canvas ref="c"></canvas>
              </div>
              <!-- step2 -->
              <div class="controls" v-show="step == 2" v-if="isPC()">
                <label class="mb-5">
                  <span class="h4 white-balance" :class="{active: isActivewhiteBalanceBtn }" @click="whiteBalanceOnclick">ホワイトバランス</span>
                </label>
                <label>
                  <span class="h4 brightness">明るさ:</span>
                  <label class="mx-1 c-switch form-check-label c-switch-pill c-switch-opposite-primary c-switch-label">
                    <input type="checkbox" class="c-switch-input form-check-input" v-model="brightnessChecked" @change="brightnessOnclick">
                    <span data-checked="ON" data-unchecked="OFF" class="c-switch-slider"></span>
                  </label>
                </label>
                <div class="range-wrap mb-5">
                  <label><input type="range" v-model="brightnessValue" @change="brightnessValueOninput" min="-1" max="1" step="0.003921"></label>
                </div>  
                <label>
                  <span class="h4 gamma">色補正:</span>
                  <label class="mx-1 c-switch form-check-label c-switch-pill c-switch-opposite-primary c-switch-label">
                    <input type="checkbox" class="c-switch-input form-check-input" v-model="gammaChecked" @change="gammaOnclick">
                    <span data-checked="ON" data-unchecked="OFF" class="c-switch-slider"></span>
                  </label>
                </label>
                <div class="range-wrap mb-5">
                  <label><input type="range" v-model="gammaRedValue" @change="gammaOninput" min="0.2" max="2.2" step="0.003921"></label>
                  <label><input type="range" v-model="gammaGreenValue" @change="gammaOninput" min="0.2" max="2.2" step="0.003921"></label>
                  <label><input type="range" v-model="gammaBlueValue" @change="gammaOninput" min="0.2" max="2.2" step="0.003921"></label>
                </div>
                <label class="mb-5">
                  <span class="h4 selectable" :class="{active: isActiveSelectBtn }" @click="selectObject">拡大・縮小</span>
                </label>
                <div class="text-center">
                  <button type="button" class="btn btn-success" @click="goStep1">アップロード画面に戻る</button>
                  <button type="button" class="btn btn-success" @click="goStep3">診断へ進む</button>
                </div>
              </div>
              <div class="header-menu" v-show="step == 2" v-if="!isPC()">
                <ul>
                  <li class="btn-left-sp" @click="goStep1"><span></span></li>
                  <li class="btn-play-sp"></li>
                  <li class="btn-download-sp"></li>
                  <li class="btn-mymenu-sp"><span @click.stop="openMenu"></span></li>
                  <li class="btn-right-sp" @click="goStep3"><span></span></li>
                </ul>
              </div>
              <div class="footer-menu" v-show="step == 2" v-if="!isPC()">
                <ul>
                  <li><span class="btn-white-balance-sp" :class="{active: isActivewhiteBalanceBtn }" @click="whiteBalanceOnclick"></span></li>
                  <li><span class="btn-brightness-sp" @click="openBrightness"></span></li>
                  <li><span class="btn-gamma-sp" @click="openGamma"></span></li>
                  <li><span class="btn-selectable-sp" :class="{active: isActiveSelectBtn }" @click="selectObject"></span></li>
                </ul>
              </div>
              <div class="over-brightness-menu" v-show="isShowMenuBrightness">
                <span class=close @click="closeBrightness"></span>
                <span class="h4 brightness">明るさ:</span>
                <label class="mx-1 c-switch form-check-label c-switch-pill c-switch-opposite-primary c-switch-label">
                  <input type="checkbox" class="c-switch-input form-check-input" v-model="brightnessChecked" @change="brightnessOnclick">
                  <span data-checked="ON" data-unchecked="OFF" class="c-switch-slider"></span>
                </label>
                <div class="range-wrap mb-5 mt-4">
                  <label><input type="range" v-model="brightnessValue" @change="brightnessValueOninput" min="-1" max="1" step="0.003921"></label>
                </div>
              </div>
              <div class="over-gamma-menu" v-show="isShowMenuGamma">
                <span class=close @click="closeGamma"></span>
                <label>
                  <span class="h4 gamma">色補正:</span>
                  <label class="mx-1 c-switch form-check-label c-switch-pill c-switch-opposite-primary c-switch-label">
                    <input type="checkbox" class="c-switch-input form-check-input" v-model="gammaChecked" @change="gammaOnclick">
                    <span data-checked="ON" data-unchecked="OFF" class="c-switch-slider"></span>
                  </label>
                </label>
                <div class="range-wrap mb-5">
                  <label><input type="range" v-model="gammaRedValue" @change="gammaOninput" min="0.2" max="2.2" step="0.003921"></label>
                  <label><input type="range" v-model="gammaGreenValue" @change="gammaOninput" min="0.2" max="2.2" step="0.003921"></label>
                  <label><input type="range" v-model="gammaBlueValue" @change="gammaOninput" min="0.2" max="2.2" step="0.003921"></label>
                </div>
              </div>
              <!-- step3 -->
              <div class="controls step3" v-show="step == 3" v-if="isPC()">
                <div class="list-head">
                  <span>春</span>
                  <span>夏</span>
                  <span>秋</span>
                  <span>冬</span>
                </div>
                <ul id="colors" class="mt-3">
                  <li v-for="color in colorsName" class="mb-4">
                    <label class="basecolor-name h2">{{color.japanese}}<input type="checkbox" v-model="checkColors[color.name].All" @click="changeColorGroupAll(color.name)"><span></span></label>
                    <label v-bind:class="{active: checkColorsActive(color.name,'Sp') }"><input type="checkbox" v-model="checkColors[color.name].Sp"><span></span></label>
                    <label v-bind:class="{active: checkColorsActive(color.name,'Su') }"><input type="checkbox" v-model="checkColors[color.name].Su"><span></span></label>
                    <label v-bind:class="{active: checkColorsActive(color.name,'Au') }"><input type="checkbox" v-model="checkColors[color.name].Au"><span></span></label>
                    <label v-bind:class="{active: checkColorsActive(color.name,'Wi') }"><input type="checkbox" v-model="checkColors[color.name].Wi"><span></span></label>
                  </li>
                </ul>
                <CRow class="mb-5 mt-4">
                  <CCol col="3">
                    <button type="button" class="btn-play" v-if="!isActiveAutoPlay" @click="startAutoPlay()">AUTO</button>
                    <button type="button" class="btn-stop" v-if="isActiveAutoPlay" @click="stopAutoPlay">STOP</button>
                  </CCol>
                  <CCol col="4">
                    <CSelect 
                      :options="autoPlayIntervalTimeOptions" 
                      :value.sync="autoPlayIntervalTime" 
                      @change="changeIntervalTime" />
                  </CCol>
                  <CCol col="5" class="text-center">
                    <button type="button" class="btn-download" @click="svgDownload">写真を保存</button>
                  </CCol>
                </CRow>
                <div class="text-center">
                  <button type="button" class="btn btn-success" @click="goStep1">アップロード画面に戻る</button>
                  <button type="button" class="btn btn-success" @click="goStep2">調整に戻る</button>
                </div>
              </div>
              <div class="header-menu" v-show="step == 3" v-if="!isPC()">
                <ul>
                  <li class="btn-left-sp"><span @click="goStep2"></span></li>
                  <li class="btn-play-sp" v-if="!isActiveAutoPlay" ><span @click.stop="openTime"></span></li>
                  <li class="btn-stop-sp" v-if="isActiveAutoPlay" ><span @click="stopAutoPlay"></span></li>
                  <li class="btn-download-sp"><span @click="svgDownload"></span></li>
                  <li class="btn-mymenu-sp"><span @click.stop="openMenu"></span></li>
                  <li class="btn-right-sp"></li>
                </ul>
              </div>
              <div class="footer-menu onebtn" v-show="step == 3" v-if="!isPC()">
                <ul>
                  <li><span class="btn-color-sp" @click="openColor"></span></li>
                </ul>
              </div>
              <div class="over-color-menu" v-if="!isPC()" v-show="isShowMenuColor || isActiveAutoPlay || isActiveSwipe">
                <span class=close @click="closeColor" v-show="isShowMenuColor"></span>
                <div class="over-color-menu-body">               
                  <div class="list-head">
                    <span>春</span>
                    <span>夏</span>
                    <span>秋</span>
                    <span>冬</span>
                  </div>
                  <ul id="colors" class="mt-3">
                    <li v-for="color in colorsName" v-show="isShowMenuColor || ( (isActiveAutoPlay || isActiveSwipe) && checkColorsActive(color.name) )">
                      <label><input type="checkbox" v-model="checkColors[color.name].All" @click="changeColorGroupAll(color.name)"><span></span></label>
                      <label class="basecolor-name h2" :class="color.name"></label>
                      <label v-bind:class="{active: checkColorsActive(color.name,'Sp') }"><input type="checkbox" v-model="checkColors[color.name].Sp"><span></span></label>
                      <label v-bind:class="{active: checkColorsActive(color.name,'Su') }"><input type="checkbox" v-model="checkColors[color.name].Su"><span></span></label>
                      <label v-bind:class="{active: checkColorsActive(color.name,'Au') }"><input type="checkbox" v-model="checkColors[color.name].Au"><span></span></label>
                      <label v-bind:class="{active: checkColorsActive(color.name,'Wi') }"><input type="checkbox" v-model="checkColors[color.name].Wi"><span></span></label>
                    </li>
                  </ul>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
export default {
  name: 'Diagnosis',
  data () {
    return {
      step: 1,
      isDropEnter: false,
      oImg: null,
      canvas: null,
      filter: null,
      clipRect: null,
      isActiveSelectBtn: false,
      isActiveAutoPlay: false,
      isActivewhiteBalanceBtn: false,
      autoPlayTimer: null,
      autoPlayIntervalTime: 300,
      autoPlayIntervalTimeOptions: [
        { value: 300,  label: '0.3' },
        { value: 500,  label: '0.5' },
        { value: 1000, label: '1',},
      ],
      brightnessChecked: false,
      brightnessValue: 0.1,
      gammaChecked: false,
      gammaRedValue: 1,
      gammaGreenValue: 1,
      gammaBlueValue: 1,
      colorsName:[
        {name: "blue",   japanese: "青" },
        {name: "yellow", japanese: "黄" },
        {name: "red",    japanese: "赤" },
        {name: "pink",   japanese: "ピ" },
        {name: "green",  japanese: "緑" },
        {name: "purple", japanese: "紫" },
        {name: "white",  japanese: "無" }
      ],
      checkColors:{
        blue:   { Sp: true, Su: true, Au: true, Wi: true, All: true },
        yellow: { Sp: true, Su: true, Au: true, Wi: true, All: true },
        red:    { Sp: true, Su: true, Au: true, Wi: true, All: true },
        pink:   { Sp: true, Su: true, Au: true, Wi: true, All: true },
        green:  { Sp: true, Su: true, Au: true, Wi: true, All: true },
        purple: { Sp: true, Su: true, Au: true, Wi: true, All: true },
        white:  { Sp: true, Su: true, Au: true, Wi: true, All: true }
      },
      colorsVal:{
        blue:   { Sp: "#1d86ae", Su: "#80a6ce", Au: "#00606a", Wi: "#0c1a6f" },
        yellow: { Sp: "#fef09f", Su: "#e6f5b0", Au: "#e5c73e", Wi: "#fff068" },
        red:    { Sp: "#fe4118", Su: "#d52e52", Au: "#743526", Wi: "#b10e34" },
        pink:   { Sp: "#fa8086", Su: "#fba7be", Au: "#e37f61", Wi: "#eb416f" },
        green:  { Sp: "#73c262", Su: "#a0d794", Au: "#56561a", Wi: "#1d4b44" },
        purple: { Sp: "#524b8c", Su: "#cbbddc", Au: "#531460", Wi: "#3f007d" },
        // white:  { Sp: "#fef2e0", Su: "#fef1e6", Au: "#ebdecd", Wi: "#ffffff" }
        white:  { Sp: "#a34a02", Su: "#9d979e", Au: "#4c3624", Wi: "#000000" }
      },
      colorsNow:['blue','Sp'],
      labelTxt: {
        labelOn: 'ON',
        labelOff: 'OFF'
      },
      isShowMenu: false,
      canvas_width: 640,
      canvas_height: 800,
      isShowMenuBrightness: false,
      isShowMenuGamma: false,
      isShowMenuColor: false,
      isShowTime: false,
      isTouching: false,
      pointX: 0,
      isActiveSwipe: false,
      isActiveSwipeTimer: null
    }
  },
  mounted: function () {
    this.init();
    window.addEventListener("orientationchange", function() {
      if (confirm("画面向きを変更すると編集が取り消されますがよろしいですか？")) {
        location.href = "/app/color/diagnosis";
      }
    });
  },
  methods: {
    init(){
      let webglBackend = new fabric.WebglFilterBackend();
      fabric.filterBackend = new fabric.Canvas2dFilterBackend()
      fabric.Object.prototype.transparentCorners = true;
      let clip_width = Math.floor(this.canvas_width * 0.496875);
      let clip_height = Math.floor(this.canvas_height * 0.6875);
      if(window.innerWidth < 1200){
        this.canvas_width = window.innerWidth;
        this.canvas_height = window.innerHeight - 70;
        clip_width = Math.floor(this.canvas_width * 0.584);
        clip_height = Math.floor(this.canvas_height * 0.634);
      }
      this.$refs.c.width = this.canvas_width;
      this.$refs.c.height = this.canvas_height;
      this.canvas = new fabric.Canvas(this.$refs.c);
      this.canvas.backgroundColor = "#000";
      this.filter = fabric.Image.filters;
      this.clipRect = new fabric.Rect({
        originX: 'left',
        originY: 'top',
        left: (this.canvas_width - clip_width) / 2,
        top: (this.canvas_height - clip_height) / 2,
        width: clip_width,
        height: clip_height,
        fill: '#DDD',
        strokeWidth: 0,
        selectable: false
      }).set({
        clipFor: 'clip'
      });
      this.canvas.add(this.clipRect);
      fabric.Image.fromURL('white.jpg', (img) => {
        this.oImg = img.set({
          left: 50,
          top: 50,
          objectCaching: false,
          hasRotatingPoint: false,
          selectable: false,
          clipName: 'clip',
          clipTo: (ctx) => { 
            this.oImg.setCoords();
            var clipRect = this.clipRect;
            var scaleXTo1 = (1 / this.oImg.scaleX);
            var scaleYTo1 = (1 / this.oImg.scaleY);
            ctx.save();

            var ctxLeft = -( this.oImg.width / 2 ) + clipRect.strokeWidth;
            var ctxTop = -( this.oImg.height / 2 ) + clipRect.strokeWidth;
            var ctxWidth = clipRect.width - clipRect.strokeWidth;
            var ctxHeight = clipRect.height - clipRect.strokeWidth;
            ctx.translate( ctxLeft, ctxTop );
            ctx.scale(scaleXTo1, scaleYTo1);
            ctx.beginPath();
            ctx.rect(
              clipRect.left - this.oImg.oCoords.tl.x,
              clipRect.top - this.oImg.oCoords.tl.y,
              clipRect.width,
              clipRect.height
            );
            ctx.closePath();
            ctx.restore();
          }
        });
        this.canvas.add(this.oImg);
        this.applyFilter(0, new this.filter.WhiteBalance({
          whitebalance: { x:-1, y:-1 }
        }));
      });
      this.canvas.on('after:render', (opt) => { 
        this.isActiveSelectBtn = this.isSelectObject();
      });
      this.canvas.on('mouse:up', (opt) => {
        if(this.isActivewhiteBalanceBtn){
          this.whiteBalanceOninput(opt);
        }
      });
      this.$nextTick(function() {
        window.addEventListener('touchstart', this.touchStartEvent, { passive: false });
        window.addEventListener('touchend', this.touchEndEvent, { passive: false });
      });
    },
    dragEnter() {
      this.isDropEnter = true;
    },
    dragLeave(){
      this.isDropEnter = false;
    },
    dropFile(){
      this.setImage(event.dataTransfer.files[0]);
    },
    onFileChange(e){
      const files = e.target.files || e.dataTransfer.files;
      this.setImage(files[0]);
    },
    setImage(file){
      let reader = new FileReader();
      reader.onload = (file) => {
        this.addImage(file.target.result);
      }
      reader.readAsDataURL(file);
      this.isEnter = false;
      this.step = 2;
    },
    selectObject() {
      if(this.isSelectObject()){
        this.isActiveSelectBtn = false;
        this.canvas.discardActiveObject();
      }else{
        this.isActivewhiteBalanceBtn = false;
        this.isActiveSelectBtn = true;
        this.canvas.setActiveObject(this.oImg);
      }
      this.canvas.renderAll();
    },
    isSelectObject(){
      try {
        if(!this.canvas.getActiveObject()){
          return false;
        }else{
          return true;
        }
      } catch (error) {
        return false;
      }
    },
    addImage(imgLink) {
      let adjustedScale = 0.9;
      fabric.Image.fromURL(imgLink, (img) => {
        const maxSize = Math.max(img.width,img.height);
        const maxSide = (img.width > img.height) ? "width" : "height" ;
        if(maxSize > this.canvas[maxSide]){
          adjustedScale = (this.canvas[maxSide] - 100 ) / maxSize; 
        }
        this.oImg.setSrc(img.getSrc(), () => {
          this.canvas.renderAll()
          this.oImg.setCoords();
        },{
          left: 50,
          top: 50
        }).scale(adjustedScale);
      });
    },
    goStep1(){
      this.step = 1;
    },
    goStep2(){
      this.step = 2;
      this.isActiveAutoPlay = false;
    },
    goStep3(){
      this.step = 3;
      this.colorsNow = ['white','Wi'];

      this.isActiveSelectBtn = false;
      this.canvas.discardActiveObject();
      this.canvas.renderAll();

      this.setNextColor();
      this.isActivewhiteBalanceBtn = false;
    },
    colorChangeLeft(){
      this.setNextColor(-1);
      this.changeActiveSwipe();
    },
    colorChangeRight(){
      this.setNextColor();
      this.changeActiveSwipe();
    },
    changeActiveSwipe(){
      if(!this.isPC()){
        clearTimeout(this.isActiveSwipeTimer);
        this.isActiveSwipe = true;
        this.isActiveSwipeTimer = setTimeout(() => {
          this.isActiveSwipe = false;
        }, 3000);
      }
    },
    colorMain(){
      return [ "blue", "yellow", "red", "pink", "green", "purple", "white" ]
    },
    colorSub(){
      return [ "Sp", "Su", "Au", "Wi" ]
    },
    setNextColor(vector = 1){
      let next = this.getNextColorPath(vector);
      this.colorsNow = next;
      this.canvas.backgroundColor = this.colorsVal[next[0]][next[1]];
      this.canvas.renderAll()
    },
    getNextColorPath(vector){
      const COLORMAIN = this.colorMain();
      const COLORSUB  = this.colorSub();
      let colorsList = [];
      COLORMAIN.forEach( main => {
        COLORSUB.forEach(sub => {
          colorsList.push({
            checked: this.checkColors[main][sub],
            path: [ main, sub ]
          })
        });        
      });
      let nowMainIndex = COLORMAIN.indexOf(this.colorsNow[0]);
      let nowSubIndex = COLORSUB.indexOf(this.colorsNow[1]);
      let nowIndex = nowMainIndex * 4 + nowSubIndex;
      let nextCandidate = null;
      for (let index = 1; index < 28; index++) {
        let nextIndex = nowIndex + (index * vector);
        if(nextIndex<0){
          nextIndex = 27 + nextIndex;
        }
        nextIndex = nextIndex % 28;
        let nextCandidate = colorsList[nextIndex];
        if(nextCandidate.checked){
          return nextCandidate.path;
          break;
        }
      }
      return null;
    },
    checkColorCheckd(nextMain, nextSub){
      return this.checkColors[nextMain][nextSub];
    },
    checkColorsActive(main,sub = null){
      if(sub){
        return (this.colorsNow[0] == main && this.colorsNow[1] == sub);
      }else{
        return this.colorsNow[0] == main;
      }
    },
    changeColorGroupAll(colorName){
      let colors = this.checkColors[colorName];
      colors.All = !colors.All;
      Object.keys(colors).forEach(function (subName) {
        colors[subName] = colors.All;
      });
    },
    applyFilter(index, filter) {
      this.oImg.filters[index] = filter;
      this.oImg.applyFilters();
      this.canvas.renderAll();
    },
    applyFilterValue(index, prop, value) {
      if (this.oImg.filters[index]) {
        this.oImg.filters[index][prop] = value;
        this.oImg.applyFilters();
        this.canvas.renderAll();
      }
    },
    brightnessOnclick(e) {
      this.applyFilter(1, this.brightnessChecked && new this.filter.Brightness({
        brightness: parseFloat(this.brightnessValue)
      }));
    },
    brightnessValueOninput() {
      this.applyFilterValue(1, 'brightness', parseFloat(this.brightnessValue));
    },
    getGammaValues(){
      const v1 = parseFloat(this.gammaRedValue);
      const v2 = parseFloat(this.gammaGreenValue);
      const v3 = parseFloat(this.gammaBlueValue);
      return [v1, v2, v3];
    },
    gammaOnclick() {
      const gammaValues = this.getGammaValues();
      this.applyFilter(2, this.gammaChecked && new this.filter.Gamma({
        gamma: gammaValues
      }));
    },
    gammaOninput() {
      const gammaValues = this.getGammaValues();
      this.applyFilterValue(2, 'gamma', gammaValues);
    },
    whiteBalanceOnclick() {
      if(this.isActivewhiteBalanceBtn){
        this.isActivewhiteBalanceBtn = false;
      }else{
        this.isActivewhiteBalanceBtn = true;
        this.isActiveSelectBtn = false;
      }
      this.canvas.discardActiveObject();
      this.canvas.renderAll();
    },
    whiteBalanceOninput(mouseEvent) {
      const mousePoint = this.getMousePointInObjectOriginalScale(mouseEvent);
      if(
          mousePoint.x < this.oImg.width && 
          mousePoint.y < this.oImg.height &&
          mousePoint.x > 0 && mousePoint.y > 0
        ){
          this.applyFilterValue(0, 'whitebalance', mousePoint);
        }
    },
    getMousePointInObjectOriginalScale(mouseEvent){
      return {
        x: Math.floor((mouseEvent.pointer.x - this.oImg.left) / this.oImg.scaleX),
        y: Math.floor((mouseEvent.pointer.y - this.oImg.top) / this.oImg.scaleY)
      }
    },
    startAutoPlay(time = 0){
      if(time == 0){
        time = this.autoPlayIntervalTime;
      }
      this.isActiveAutoPlay = true;
      clearInterval(this.autoPlayTimer);
      this.autoPlayTimer = setInterval(this.setNextColor, time);
      // スワイプ用のフラグとタイマーをリセット
      clearTimeout(this.isActiveSwipeTimer);
      this.isActiveSwipe = false;
    },
    stopAutoPlay(){
      this.isActiveAutoPlay = false;
      clearInterval(this.autoPlayTimer);
    },
    changeIntervalTime(){
      if(this.isActiveAutoPlay){
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = setInterval(this.setNextColor, this.autoPlayIntervalTime);
      }
    },
    svgDownload(){
      const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
      if(isChromeIOS){
        alert("新しいタブで画像が開きます。画像を長押し表示されるメニューから保存を行ってください。");
        const reader = new FileReader();
        this.$refs.c.toBlob( (blod) => {
          const URL = window.URL || window.webkitURL;
          window.open(URL.createObjectURL(blod), '_blank');
        });
      }else{
        this.$refs.c.toBlob(function(blob){
          saveAs(blob, "color_diagnostics.png",{},"_blank");
        });
      }
    },
    goMyAccount() {
      this.$router.push({path: `/app/color/users/${localStorage.userId}`});
    },
    openMenu(){
      this.isShowMenu = true;
    },
    openTime(){
      this.isShowTime = true;
    },
    closeMenu(){
      this.isShowMenu = false;
      this.isShowTime = false;
    },
    openBrightness(){
      this.isShowMenuBrightness = true;
    },
    closeBrightness(){
      this.isShowMenuBrightness = false;
    },
    openGamma(){
      this.isShowMenuGamma = true;
    },
    closeGamma(){
      this.isShowMenuGamma = false;
    },
    openColor(){
      this.isShowMenuColor = true;
    },
    closeColor(){
      this.isShowMenuColor = false;
    },
    isPC(){
      return window.innerWidth > 1200
    },
    touchStartEvent(e) {
      if(this.step == 3 && !this.isPC()){
        this.isTouching = true;
        this.pointX = e.changedTouches[0].pageX;
      }
    },
    touchEndEvent(e) {
      if(this.step == 3 &&  !this.isPC() && this.isTouching){
        this.isTouching = false;
        if(Math.abs(e.changedTouches[0].pageX - this.pointX) > 50){
          if(e.changedTouches[0].pageX - this.pointX > 0){
            this.colorChangeRight();
          }else{
            this.colorChangeLeft();
          }
        }
      }
    },
  }
}
</script>
